import React from "react";
import {
  buttonSizeClasses,
  buttonToneClasses,
  DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME,
  joinClasses,
} from "./shared.js";

export function ActionButton({
  as: Component = "button",
  children,
  className = "",
  isLoading = false,
  loadingLabel = "",
  size = "md",
  tone = "ghost",
  type,
  ...props
}) {
  const componentProps = {
    ...props,
  };

  if (Component === "button") {
    componentProps.type = type || "button";
  }

  return (
    <Component
      className={joinClasses([
        `inline-flex items-center justify-center gap-2 border font-semibold transition duration-150 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60 disabled:shadow-none disabled:translate-y-0 ${DISPATCH_ROUTE_PILL_RADIUS_CLASS_NAME}`,
        buttonSizeClasses[size] || buttonSizeClasses.md,
        buttonToneClasses[tone] || buttonToneClasses.ghost,
        className,
      ])}
      aria-busy={isLoading ? "true" : undefined}
      {...componentProps}
    >
      {isLoading ? (
        <span
          aria-hidden="true"
          className={joinClasses([
            "inline-flex h-4 w-4 animate-spin rounded-full border-2",
            tone === "ghost" || tone === "subtle" || tone === "icon" || tone === "icon-success" || tone === "icon-reassign" || tone === "icon-suspend" || tone === "glass"
              ? "border-accent/20 border-t-accent"
              : "border-white/30 border-t-white",
          ])}
        />
      ) : null}
      <span>{isLoading && loadingLabel ? loadingLabel : children}</span>
    </Component>
  );
}
